/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ProductsearchComponent as ɵb} from './lib/components/productsearch/productsearch.component';
export {IsSuperUserDirective as ɵa} from './lib/directives/issuperuser.directive';